:host{display:flex;flex-direction:column;flex:1;min-width:0;min-height:0}:host.no-placeholders ::ng-deep .cdk-drag-placeholder{display:none}
/*# sourceMappingURL=drop-list.component-E6VDZH4E.css.map */
